import Queue from '@/models/Queue';
import { ScopesTypes } from '@/Types/ScopesTypes';

export interface FetchSlotsForQueueData {
  queueUuid: string;
  scope: ScopesTypes;
}

export interface QueueState {
  queues: Queue[];
  queuesLoading : boolean;
  userQueues: Queue[];
  queue: Queue;
  queueUuid: string;
  isLoading: boolean;
  scope?: number;
}

export enum MutationTypes {
  SET_QUEUES = 'SET_QUEUES',
  SET_QUEUES_LOADING = 'SET_QUEUES_LOADING',
  SET_USER_QUEUES = 'SET_USER_QUEUES',
  SET_QUEUE = 'SET_QUEUE',
  SET_SLOTS_FOR_QUEUE = 'SET_SLOTS_FOR_QUEUE',
  SET_SELECTED_QUEUE_UUID = 'SET_SELECTED_QUEUE_UUID',
  SET_SLOT_FOR_USER_QUEUES_AFTER_ENROLL = 'SET_SLOT_FOR_USER_QUEUES_AFTER_ENROLL',
  SET_SLOT_AFTER_SIGN_OFF = 'SET_SLOT_AFTER_SIGN_OFF',
  SET_IS_LOADING = 'SET_IS_LOADING'
}

export enum ActionTypes {
  FETCH_QUEUES = 'FETCH_QUEUES',
  FETCH_USER_QUEUES = 'FETCH_USER_QUEUES',
  FETCH_QUEUE = 'FETCH_QUEUE',
  FETCH_SLOTS_FOR_QUEUE = 'FETCH_SLOTS_FOR_QUEUE',
  ENROLL_TO_SLOT = 'ENROLL_TO_SLOT',
  SIGN_OFF_FROM_SLOT = 'SIGN_OFF_FROM_SLOT',
  SELECT_QUEUE = 'SELECT_QUEUE',
  CLEAR_SELECTED_QUEUE = 'CLEAR_SELECTED_QUEUE',
  REMOVE_SLOT = 'REMOVE_SLOT',
  MERGE_TO_QUEUE = 'MERGE_TO_QUEUE'
}

export enum GetterTypes {
  GET_IS_LOADING = 'GET_IS_LOADING',
  GET_QUEUES = 'GET_QUEUES',
  GET_QUEUES_LOADING = 'GET_QUEUES_LOADING',
  GET_USER_QUEUES = 'GET_USER_QUEUES',
  GET_QUEUE = 'GET_QUEUE',
  GET_SELECTED_QUEUE_UUID = 'GET_SELECTED_QUEUE_UUID'
}

